const prefix = "[FORMS]";

export default {
    FETCH_FORM_SCHEMA_REQUEST: `${prefix} FETCH_FORM_SCHEMA_REQUEST`,
    FETCH_FORM_SCHEMA_SUCCESS: `${prefix} FETCH_FORM_SCHEMA_SUCCESS`,
    FETCH_FORM_SCHEMA_FAILED: `${prefix} FETCH_FORM_SCHEMA_FAILED`,
};
